module.exports = __webpack_public_path__ + "media/images/city/096-eiffel-tower-de76ed406badc4d63afce11ab0644127.svg";